/**
 * sla-fecha-estimada.js — Librería Casa Drojan
 * Calcula "recíbelo antes del X" en cliente, para que la fecha siempre sea
 * hoy + plazo, aunque la página esté cacheada. Dos modos, según qué atributo
 * lleve el elemento:
 *
 *   - data-plazo-dias="N"   → venta bajo pedido (piloto Azeta): N son días
 *     de calendario, calculados en el servidor a partir del histórico real
 *     del distribuidor (metafield sla_bajo_pedido.plazo_entrega_dias).
 *
 *   - data-dias-habiles="N" → catálogo normal en stock: N son días HÁBILES
 *     (fin de semana no cuenta), pensado para envío + margen de seguridad.
 *     Si el pedido se hace en fin de semana, cuenta como hecho el lunes.
 */
(function () {
  function esFinDeSemana(fecha) {
    var dia = fecha.getDay();
    return dia === 0 || dia === 6; // domingo, sábado
  }

  function formatear(fecha) {
    return fecha.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
  }

  function calcularFechaCalendario(diasCalendario) {
    var fecha = new Date();
    fecha.setDate(fecha.getDate() + diasCalendario);
    return formatear(fecha);
  }

  function calcularFechaHabil(diasHabiles) {
    var fecha = new Date();
    // Si el pedido se hace en fin de semana, cuenta como hecho el lunes.
    while (esFinDeSemana(fecha)) {
      fecha.setDate(fecha.getDate() + 1);
    }
    var restantes = diasHabiles;
    while (restantes > 0) {
      fecha.setDate(fecha.getDate() + 1);
      if (!esFinDeSemana(fecha)) {
        restantes -= 1;
      }
    }
    return formatear(fecha);
  }

  function pintar(el) {
    if (el.dataset.diasHabiles) {
      var diasHabiles = parseInt(el.dataset.diasHabiles, 10);
      if (!diasHabiles || diasHabiles <= 0) {
        el.remove();
        return;
      }
      el.textContent = 'Recíbelo antes del ' + calcularFechaHabil(diasHabiles);
      el.removeAttribute('data-loading');
      return;
    }

    var plazo = parseInt(el.dataset.plazoDias, 10);
    if (!plazo || plazo <= 0) {
      el.remove();
      return;
    }
    el.textContent = 'Recíbelo antes del ' + calcularFechaCalendario(plazo);
    el.removeAttribute('data-loading');
  }

  function pintarTodos(root) {
    (root || document)
      .querySelectorAll('.sla-fecha-estimada[data-plazo-dias], .sla-fecha-estimada[data-dias-habiles]')
      .forEach(pintar);
  }

  document.addEventListener('DOMContentLoaded', function () {
    pintarTodos(document);
  });

  // El cart drawer y la sección de producto se re-renderizan (innerHTML) tras
  // cambios de variante/cantidad — un MutationObserver es más fiable aquí que
  // suponer qué evento personalizado dispara cada bloque de este tema.
  var pendiente = null;
  var observer = new MutationObserver(function () {
    if (pendiente) return;
    pendiente = requestAnimationFrame(function () {
      pintarTodos(document);
      pendiente = null;
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.slaPintarFechaEstimada = pintarTodos;
})();
